(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1280px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whalebud-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whalebud-carousel-slider')) {
    customElements.define('whalebud-carousel-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.track = this.querySelector('[data-whalebud-carousel-track]');
        this.slides = [...this.querySelectorAll('[data-whalebud-carousel-slide]')];
        this.dots = [...this.querySelectorAll('[data-whalebud-carousel-dot]')];
        if (!this.track || !this.slides.length) return;
        this.querySelector('[data-whalebud-carousel-prev]')?.addEventListener('click', () => this.goTo(this.currentIndex() - 1), { signal });
        this.querySelector('[data-whalebud-carousel-next]')?.addEventListener('click', () => this.goTo(this.currentIndex() + 1), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.whalebudCarouselDot)), { signal }));
        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.currentIndex() + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        let frame;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.update());
        }, { passive: true, signal });
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('.whalebud-carousel__youtube-trigger');
          if (trigger) this.loadYoutube(trigger.closest('[data-whalebud-youtube]'));
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-whalebud-carousel-slide]');
          if (slide && this.contains(slide)) this.goTo(this.slides.indexOf(slide));
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = null;
      }
      currentIndex() {
        return this.slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - this.track.scrollLeft) < Math.abs(this.slides[best].offsetLeft - this.track.scrollLeft) ? index : best, 0);
      }
      goTo(index) {
        const target = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
        if (!target) return;
        this.track.scrollTo({ left: target.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const index = this.currentIndex();
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
        const prev = this.querySelector('[data-whalebud-carousel-prev]');
        const next = this.querySelector('[data-whalebud-carousel-next]');
        if (prev) prev.disabled = this.track.scrollLeft <= 1;
        if (next) next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      }
      loadYoutube(wrapper) {
        if (!wrapper) return;
        const width = window.innerWidth;
        const id = width >= 990 ? wrapper.dataset.whalebudYoutubePc : width >= 750 ? wrapper.dataset.whalebudYoutubePad : wrapper.dataset.whalebudYoutubeM;
        if (!id) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
        iframe.title = wrapper.dataset.whalebudYoutubeTitle || 'YouTube video';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        wrapper.replaceChildren(iframe);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whalebud-image-text-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whalebud-youtube')) {
    customElements.define(
      'whalebud-youtube',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.whalebudInitialized === 'true') return;

          const trigger = this.querySelector('.whalebud-image-text__youtube-trigger');
          if (!trigger) return;

          this.dataset.whalebudInitialized = 'true';
          trigger.addEventListener('click', () => this.loadPlayer());
        }

        loadPlayer() {
          const viewportWidth = window.innerWidth;
          const videoId = viewportWidth >= 990
            ? this.dataset.whalebudYoutubePc
            : viewportWidth >= 750
              ? this.dataset.whalebudYoutubePad
              : this.dataset.whalebudYoutubeM;

          if (!videoId) return;

          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
          iframe.title = this.dataset.whalebudYoutubeTitle || 'YouTube video';
          iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          this.replaceChildren(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whalebud-image-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('whalebud-youtube')) {
    customElements.define(
      'whalebud-youtube',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.whalebudInitialized === 'true') return;

          const trigger = this.querySelector('.whalebud-image-text__youtube-trigger');
          if (!trigger) return;

          this.dataset.whalebudInitialized = 'true';
          trigger.addEventListener('click', () => this.loadPlayer());
        }

        loadPlayer() {
          const viewportWidth = window.innerWidth;
          const videoId = viewportWidth >= 990
            ? this.dataset.whalebudYoutubePc
            : viewportWidth >= 750
              ? this.dataset.whalebudYoutubePad
              : this.dataset.whalebudYoutubeM;

          if (!videoId) return;

          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
          iframe.title = this.dataset.whalebudYoutubeTitle || 'YouTube video';
          iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          this.replaceChildren(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
